import API from '@/amplify/api';
import Constant from '@/common/constant/Constant';
import { getApiPublic, publicGetKnowledgeList } from '@/graphql/queries';
import { updateApiPublic } from '@/graphql/mutations';

export const getPublicAPI = async (APIClient, params, authMethod = Constant.AUTH_MODE_API_KEY) => {
    try {

        let request = {
            query: getApiPublic,
            variables: {
                params: JSON.stringify(params)
            },
            authMode: authMethod
        };

        // require sign request
        if(authMethod === Constant.AUTH_MODE_USER_POOLS){
            delete request.authMode
        };

        let res = await API.graphql(request);
        return res.data.getApiPublic;
    } catch (err) {
        console.log('getPublicAPI err', err);
        return {};
    }
};

export const updatePublicAPI = async (APIClient, params) => {
    try {
        let res = await API.graphql({
            query: updateApiPublic,
            variables: {
                updateApiPublicRequestDto: JSON.stringify({
                    ...params
                })
            },
            authMode: Constant.AUTH_MODE_API_KEY,
        });
        return res.data.updateApiPublic;
    } catch (err) {
        console.log('updatePublicAPI err', err);
        return {};
    }
};

export const publicGetKnowledgeListAPI = async (APIClient, params) => {
    try {
        let res = await API.graphql({
            query: publicGetKnowledgeList,
            variables: {
                params: JSON.stringify(params)
            },
            authMode: Constant.AUTH_MODE_API_KEY,
        });
        const response = res?.data?.publicGetKnowledgeList;
        return response;
    } catch (err) {
        console.log('publicGetKnowledgeListAPI err', err);
        return {};
    }
};